import { formatEndpoint } from '@frontend/duck-tape';

const namespace = 'drafts';

const DRAFT_TASKS_ENDPOINTS = {
  createDraftTask: () => formatEndpoint('', namespace),
  createTaskFromDraftTask: (id: string) => formatEndpoint(`${id}/create-task`, namespace),
  deleteDraftTask: (id: string) => formatEndpoint(`${id}`, namespace),
  editAfterFailure: (id: string) => formatEndpoint(`${id}/edit-after-failure`, namespace),
  generateSlots: (id: string) => formatEndpoint(`${id}/generate-slots`, namespace),
  listDraftTasks: () => formatEndpoint('', namespace),
  retrieveDraftTask: (id: string) => formatEndpoint(`${id}`, namespace),
  submitForReview: (id: string) => formatEndpoint(`${id}/submit-for-review`, namespace),
  submitIQAnswers: (id: string) => formatEndpoint(`${id}/submit-answers`, namespace),
  updateDraftTask: (id: string) => formatEndpoint(`${id}`, namespace),
};

export default DRAFT_TASKS_ENDPOINTS;
